import { AccountingLoanEntry, Loan } from 'v2-types/order';

export function formatPercent(value: number, decimals?: number) {
  const percent = value * 100;
  const cleaned = decimals !== undefined
    ? percent.toFixed(decimals)
    : parseFloat(percent.toFixed(10)).toString();
  return `${cleaned}%`;
}

export function orderAccountingByDescription(accounting: AccountingLoanEntry[]) {
  return accounting.sort((entryA, entryB) => entryA.description.localeCompare(entryB.description));
}

export function getLoanFormDataFromLoan(loan: Loan) {
  const {
    _id,
    accounting,
    estate,
    interests,
    term_months,
    term_years,
    ...rest } = loan;

  return rest;
}